// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// BROWSER CONFIG SCHEMA
/////////////////////////////////////////

export const BrowserConfigSchema = z.object({
})

export type BrowserConfig = z.infer<typeof BrowserConfigSchema>

export default BrowserConfigSchema;
